// 全民K歌
import songIndex from '@/views/entertainment/song/index'

const kgRoutes = Array.from({ length: 15 }, (_, i) => ({
  path: `song/kg/index${i + 1}`,
  name: `song/kg/Index${i + 1}`,
  component: () => import(`@/views/entertainment/song/kg/index${i + 1}.vue`)
}))
const branchRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `song/kg/branch/index${i + 1}`,
  name: `song/kg/branch/Index${i + 1}`,
  component: () => import(`@/views/entertainment/song/kg/branch/index${i + 1}.vue`)
}))

export default {
  path: '/entertainment',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'song/index',
      name: 'songIndex',
      component: songIndex
    },
    // 全民K歌，开始
    ...kgRoutes,
    ...branchRoutes
    // 全民K歌，结束

  ]
}
